import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz'
import { addDays, addMilliseconds } from 'date-fns'

export function getStartOfDayInTimezone(dateValue: string, timezone: string) {
  return zonedTimeToUtc(dateValue, timezone).toISOString()
}

export function getEndOfDayInTimezone(dateValue: string, timezone: string) {
  return addMilliseconds(addDays(zonedTimeToUtc(dateValue, timezone), 1), -1).toISOString()
}

export function getDateValueInTimezone(isoString: string, timezone: string, format: string) {
  if (isoString) {
    return formatInTimeZone(new Date(isoString), timezone, format)
  }
}

export function isDateString(input: string) {
  return input && !isNaN(Date.parse(input))
}
